/**
 * JeriCommerce Pass API · staging
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RewardDto { 
    id: string;
    couponId: string;
    title: string;
    description: string;
    image: string;
    visibilityRules: Array<string>;
    redeemabilityRules: Array<string>;
    /**
     * Fixed rewards cost `redeemCost` points. Dynamic rewards let the customer choose the points to convert.
     */
    type?: RewardDto.TypeEnum;
    redeemCost: number;
    /**
     * Dynamic rewards only: discount amount granted per redeemed point.
     */
    currencyPerPoint?: number | null;
    /**
     * Dynamic rewards only: minimum points per redemption.
     */
    minPoints?: number | null;
    /**
     * Dynamic rewards only: maximum points per redemption.
     */
    maxPoints?: number | null;
    order: number;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
}
export namespace RewardDto {
    export const TypeEnum = {
        Fixed: 'fixed',
        Dynamic: 'dynamic'
    } as const;
    export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];
}


